/**
 * @module lib/ReducerUtils
 * common utils for reducers
 */
import { Map } from 'immutable';
import { filterActions } from 'redux-ignore';

import autoMapper from '../store/utils/autoMapper';

export function transformDataReducer(fetcher: $TSFixMe, transform: $TSFixMe) {
  return (state: $TSFixMe) => {
    return state.mergeDeep(autoMapper(fetcher(), transform));
  };
}

export function reduceReducers(...reducers: $TSFixMe[]) {
  return (state: $TSFixMe, action: $TSFixMe) => {
    return reducers.reduceRight((accumulatedState, reducer) => {
      return reducer(accumulatedState, action);
    }, state);
  };
}

/**
 * HoF that creates a reducing function that maps actions to case function handlers.
 * In addition this reducing function filters out all actions not contained in the handlers
 * map.
 *
 * @param  {Object/Map} initialState - this reducers initialState
 * @param  {object} handlers - a Object of key (Action) and value (case functions)
 * @returns {Function} - constructed reducer
 */
export function createReducer(initialState: $TSFixMe, handlers: $TSFixMe) {
  function reducer(state = initialState, action: $TSFixMe) {
    if (action.type && handlers[action.type]) {
      return handlers[action.type](state, action);
    }
    return state;
  }

  return filterActions(reducer, Object.keys(handlers));
}

/**
 * HoF that creates a reducing function that allows one or more child reducers to be
 * combined into a root reducer, where the root reducer can contain root-level properties.
 *
 * @param  {Object/Map} rootReducer - the root reducer, which may contain root-level properties
 * @param  {object} childReducers - an object containing child reducers of key (state) and value (reducer)
 * @returns {Function} - constructed reducer
 */
export function combineReducersWithRoot(rootReducer: $TSFixMe, childReducers: $TSFixMe) {
  return (state: $TSFixMe, action: $TSFixMe) => {
    const root = rootReducer(state, action);
    const children = Object.entries(childReducers).reduce(
      (result, [domain, reducer]) => {
        const previous = Map.isMap(state) ? state.get(domain) : state?.[domain];
        const child = (reducer as $TSFixMe)(previous, action);

        return Map.isMap(result)
          ? (result as $TSFixMe).set(domain, child)
          : { ...result, [domain]: child };
      },
      Map.isMap(root) ? Map() : {},
    );

    return Map.isMap(root) ? root.mergeDeep(children) : { ...root, ...children };
  };
}
